module.exports = __webpack_public_path__ + "img/appBar.fbdc4abc.png";